import { action } from "./index";

export const SET_TYPE = "EVENTS/SET_TYPE";
export const setType = (eventsType) => action(SET_TYPE, { eventsType });

export const SET_EVENTS = "EVENTS/SET_EVENTS";
export const setEvents = (events) => action(SET_EVENTS, { events });

export const SET_EVENT = "EVENTS/SET_EVENT";
export const setEvent = (event) => action(SET_EVENT, { event });

export const SET_MENU = "EVENTS/SET_MENU";
export const setMenu = (menu) => action(SET_MENU, { menu });

export const SET_GAME_FILTER = "EVENTS/SET_GAME_FILTER";
export const setGameFilter = (game) => action(SET_GAME_FILTER, { game });

export const SET_LEAGUE_FILTER = "EVENTS/SET_LEAGUE_FILTER";
export const setLeagueFilter = (league) => action(SET_LEAGUE_FILTER, { league });

export const SET_SEARCH_FILTER = "EVENTS/SET_SEARCH_FILTER";
export const setSearchFilter = (search) => action(SET_SEARCH_FILTER, { search });



// WEBPACK FOOTER //
// ./app/actions/eventsActions.js